import NoPetDetails from "./no-pet";
import PetsList from "./pets-list";
import { PetDetailsStyled } from "./pets.styles";
import Loader from "../../../../../components/loader/loader";
import useFetchPets from "./pets.hook";

const Pets = () => {
  const { pets, loading } = useFetchPets();

  const arePetsExist = pets?.length > 0;

  return (
    <PetDetailsStyled>
      {loading && <Loader />}
      {!loading && (
        <>
          {arePetsExist && (
            <PetsList arePetsExist={arePetsExist} petsList={pets} />
          )}
          {!arePetsExist && <NoPetDetails />}
        </>
      )}
    </PetDetailsStyled>
  );
};

export default Pets;
